import React, { useEffect, useRef } from 'react';
import { Animated, View } from 'react-native';
import { useAppStore } from '@restorant/core';
import { radius, useColors } from '../theme';
import { T } from './Text';

/** Bottom-centre pill that mirrors the prototype's showToast(). */
export function Toast({ bottomOffset = 24 }: { bottomOffset?: number }) {
  const colors = useColors();
  const toast = useAppStore((s) => s.toast);
  const dismissToast = useAppStore((s) => s.dismissToast);
  const anim = useRef(new Animated.Value(0)).current;

  useEffect(() => {
    if (!toast) return;
    anim.setValue(0);
    Animated.timing(anim, {
      toValue: 1,
      duration: 180,
      useNativeDriver: true,
    }).start();

    const timer = setTimeout(() => {
      Animated.timing(anim, {
        toValue: 0,
        duration: 220,
        useNativeDriver: true,
      }).start(({ finished }) => {
        if (finished) dismissToast();
      });
    }, 1600);

    return () => clearTimeout(timer);
    // Keyed on toast.id so a rapid second toast restarts the animation.
  }, [toast?.id]);

  if (!toast) return null;

  return (
    <View
      style={{
        pointerEvents: 'none',
        position: 'absolute',
        left: 0,
        right: 0,
        bottom: bottomOffset,
        alignItems: 'center',
      }}
    >
      <Animated.View
        style={{
          opacity: anim,
          transform: [
            { translateY: anim.interpolate({ inputRange: [0, 1], outputRange: [20, 0] }) },
          ],
          backgroundColor: colors.gold,
          paddingVertical: 10,
          paddingHorizontal: 18,
          borderRadius: radius.pill,
          maxWidth: '90%',
        }}
      >
        <T size={12.5} weight={700} color={colors.onGold} numberOfLines={2}>
          {toast.message}
        </T>
      </Animated.View>
    </View>
  );
}
